export default __webpack_public_path__ + "static/cdc3-cb3395098c1e4a9ccc3f7d7b6134b161.jpg";